var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ba-layout',[_c('ba-section',[_c('h2',{staticClass:"ba-title ba-title--h3",style:({ textAlign: 'center' })},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_c('ba-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }